import { Metamodel } from '../base/model';
import { IModel, IAttribute } from '../base/annotation';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format, getConnectorLegacyNameByFlag } from 'app/shared/utils/string.util';
import { driverVersions } from 'app/registries/consts/tabular-consts';
import { LinkedServiceUtils } from './linked-service.utils';

export const teradataAuthTypes = {
    Basic: 'Basic',
    Windows: 'Windows',
    LDAP: 'LDAP'
};

@Metamodel.model({
    name: adfModelTypeMap.teradata.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, getConnectorLegacyNameByFlag(stringResources.Teradata_DisplayText, true)),
        format(stringResources.ModelName_LinkedServicesTemplate, getConnectorLegacyNameByFlag(stringResources.Teradata_DisplayText, true))
    ]
})
export class TeradataLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    public static readonly SERVER: IAttribute;
    public static readonly USER_NAME: IAttribute;
    public static readonly PASSWORD: IAttribute;
    public static readonly SSL_MODE: IAttribute;

    public authOptions = [
        {
            label: stringResources.AuthenticationType_Select_Basic_Option,
            value: 'Basic'
        },
        {
            label: stringResources.AuthenticationType_Select_Windows_Option,
            value: 'Windows'
        }
    ];

    public authOptionsWithLDAP = this.authOptions.concat(
        {
            label: stringResources.AuthenticationType_LDAP,
            value: 'LDAP'
        });

    @Metamodel.attribute({
        display: stringResources.ModelName_ServerName,
        association: 'SERVER',
        templatable: true
    })
    public server?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName,
        association: 'USER_NAME',
        templatable: true
    })
    public userName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'PASSWORD',
        templatable: true,
        accepts: ['String']
    })
    public password?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.MechanismName_DiaplayName
    })
    public mechanismName?: string;

    @Metamodel.attribute({
        display: stringResources.SSL_Mode,
        association: 'SSL_MODE',
        templatable: true
    })
    public sslMode: string;

    public isOldMashupResource: boolean = false; // for existing linked service
    public isMashupResource: boolean = false; // for both new and existing linked service
    public version: driverVersions.v1 | driverVersions.v2 = driverVersions.v2;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public convertV1toV2(context: { inlineDataset?: boolean }): TeradataLinkedService {
        return LinkedServiceUtils.commonV1ToV2(context, this) as TeradataLinkedService;
    }
}
